<template>
  <v-chip
    text-color="white"
    class="secondary share-chip chip-team potential"
    :class="{ noButtonPadding: isButtonUsed }"
  >
    <v-menu
      v-model="teamMembersMenu"
      :close-on-content-click="true"
      offset-x
      top
      right
      style="z-index:999; transform:"
      origin="center center"
      transition="scale-transition"
      max-height="300"
      max-width="310"
    >
      <template v-slot:activator="{ on }">
        <v-avatar style="opacity:1;">
          <v-icon v-on="on" dark small>people</v-icon>
        </v-avatar>
      </template>
      <v-icon
        class="mt-2 mr-2"
        color="error"
        style="cursor:pointer; position:absolute; top:0; right:0;"
      >cancel</v-icon>
    </v-menu>
    {{name}} -
    <strong style="padding-left:4px">{{noUsers}}</strong>

    <v-btn v-if="displayAdd" small icon class="ma-0 ml-2" @click="clickedAdd">
      <v-icon color="white" class="add-remove">add_circle</v-icon>
    </v-btn>
    <v-btn v-if="displayCancel" small icon class="ma-0 ml-2" @click="clickedRemove">
      <v-icon color="white" class="add-remove">remove_circle</v-icon>
    </v-btn>
  </v-chip>
</template>

<script>

export default {
  name: "TeamAvatar",
  computed: {
    isButtonUsed: function() {
      return !(this.displayCancel || this.displayAdd)
    },
    noUsers: function() {
      if (this.users) {
        return this.users.length
      } else {
        return 0
      }
    }
  },
  data: () => ({
    teamMembersMenu: false
  }),
  methods: {
    clickedAdd() {
      this.$emit("clickedAdd", {
        team: { id: this.teamId, displayName: this.name },
        type: "team"
      })
    },
    clickedRemove() {
      this.$emit("clickedRemove", {
        team: { id: this.teamId, displayName: this.name },
        type: "team"
      })
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    teamId: {
      type: Number,
      required: true
    },
    users: {
      type: Array
    },
    status: String,
    size: {
      type: Number,
      default: 32
    },
    displayAdd: {
      type: Boolean,
      default: false
    },
    displayCancel: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
.noButtonPadding {
  padding-right: 10px;
}
.chip-background {
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
